import * as React from 'react';
import styles from './index.less';
import Sider from './Sider';
import Content from './Content';
import Header from './Header';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, StorageHomePageModelState } from '@/models/connect';
import {
  OnChangeActivatedBucketAction,
  OnSucceed_CreateBucket_Action,
} from '@/models/storageHomePage';
import { history } from 'umi';
import {
  ChangeAction,
  FetchInfoAction,
  storageObjectEditorInitData,
} from '@/models/storageObjectEditor';
import useUrlState from '@/hooks/useUrlState';
import { FUtil, FI18n } from '@freelog/tools-lib';
import fCreateBucket from '@/components/fCreateBucket';
import * as AHooks from 'ahooks';
import FSimpleBar from '@/components/FSimpleBar';

interface StorageProps {
  dispatch: Dispatch;
  storageHomePage: StorageHomePageModelState;
}

function Storage({ storageHomePage, dispatch }: StorageProps) {
  const [state] = useUrlState<{
    bucketName: string;
    objectID: string;
    createBucket: string;
  }>();

  React.useEffect(() => {
    if (!state.bucketName) {
      return;
    }
    dispatch<OnChangeActivatedBucketAction>({
      type: 'storageHomePage/onChangeActivatedBucket',
      payload: state.bucketName,
    });
  }, [state.bucketName]);

  AHooks.useAsyncEffect(async () => {
    if (state.createBucket) {
      const bucketName: string | null = await fCreateBucket();
      if (!bucketName) {
        history.replace(
          FUtil.LinkTo.storageSpace({
            // bucketName: storageHomePage.activatedBucket,
            bucketName: state.bucketName,
          }),
        );
        return;
      }
      dispatch<OnSucceed_CreateBucket_Action>({
        type: 'storageHomePage/onSucceed_CreateBucket',
        payload: {
          newBucketName: bucketName,
        },
      });
    }
  }, [state.createBucket]);

  React.useEffect(() => {
    handleObject();
  }, [state.objectID]);

  React.useEffect(() => {
    return () => {
      dispatch<ChangeAction>({
        type: 'storageObjectEditor/change',
        payload: {
          ...storageObjectEditorInitData,
        },
      });
    };
  }, []);

  async function handleObject() {
    await dispatch<ChangeAction>({
      type: 'storageObjectEditor/change',
      payload: {
        objectId: state.objectID || '',
      },
    });

    await dispatch<FetchInfoAction>({
      type: 'storageObjectEditor/fetchInfo',
    });
  }

  if (!storageHomePage.bucketList) {
    return null;
  }

  return (
    <div className={styles.leftRight}>
      <div className={styles.Slider}>
        <div>
          <Sider />
        </div>
      </div>
      <div className={styles.rightContent}>
        <FSimpleBar height={'calc(100vh - 70px)'} id={'rightContent'}>
          <div style={{ width: '100%', padding: '0 20px' }}>
            {storageHomePage.bucketList?.length === 0 ? null : <Header />}
            <Content />
          </div>
        </FSimpleBar>
      </div>
    </div>
  );
}

export default connect(({ storageHomePage, storageObjectEditor }: ConnectState) => ({
  storageHomePage,
  storageObjectEditor,
}))(Storage);
